<div #ResendLinkButtonContent>
  <finx-button
    [labeltext]="buttonLabel"
    class="h-100 w-100 pointer-events-none"
    [buttonStyle]="!isAllowedGlobalStyling ? contentStyle : {}"
    (click)="doAction()"
    [disabled]="countdownValue > 0"
    (keydown)="onKeyDown($event)"
    [class]="isAllowedGlobalStyling ? globalStylingClass : 'w-100'"
    [isAllowedGlobalStyling]="isAllowedGlobalStyling"
  ></finx-button>
</div>
